import LogoStyle from './style'
import { CustomLink } from 'components/common'

const Logo = () => {
    return (
        <LogoStyle className="logo">
            <CustomLink url={'/'}>
                <img src="/images/oplos.svg" alt="logo" />
            </CustomLink>
        </LogoStyle>
    )
}

export default Logo